import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="grid min-h-screen place-items-center px-5">
      <div className="max-w-xl text-center">
        <LogoMark size={44} className="mx-auto mb-10" />
        <h1 className="font-display text-5xl font-900 uppercase md:text-6xl">Pagamento annullato</h1>
        <p className="mt-4 text-[#a3b1aa]">Nessun addebito effettuato. Il tuo carrello è ancora qui.</p>
        <Link to="/" data-testid="cancel-back-home-btn" className="mt-10 inline-block bg-[#98bfa2] px-8 py-4 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">
          Torna alla home
        </Link>
      </div>
    </main>
  );
}
